import store from "../store/redux";

export const iframeParamKeys = {
    lang: "lang",
    schoolId: "schoolId",
    gender: "gender",
    supervisionId: "supervisionId",
    educationTypeId: "educationTypeId",
    bgColor: "bgColor",
};

const getByPath = (obj, path) => {
    if (!path || typeof path !== "string") return undefined;
    return path.split(".").reduce((acc, key) => acc?.[key], obj);
};

const resolveCatalogValue = (key, state) => {
    const entry = window.config?.iframeParamCatalog?.[key];
    if (!entry) return undefined;
    if (entry.value !== undefined && entry.value !== null)
        return entry.value;
    const value = getByPath(state, entry.path);
    if (value !== undefined && value !== null)
        return value;
    return entry.default;
};

const assignCatalogValue = (result, key, state) => {
    const value = resolveCatalogValue(key, state);
    if (value === undefined || value === null)
        return;
    result[key] = value;
};

export function buildIframeParams(iframeParams) {
    const state = store.getState();
    const result = {};
    if (Array.isArray(iframeParams)) {
        iframeParams.forEach(key => assignCatalogValue(result, key, state));
        return result;
    }
    if (!iframeParams || typeof iframeParams !== "object") return result;
    Object.entries(iframeParams).forEach(([key, value]) => {
        if (value === true)
            assignCatalogValue(result, key, state);
        else if (value !== undefined && value !== null)
            result[key] = value;
    });
    return result;
}

export function appendIframeParamsToUrl(iframeUrl, params) {
    if (!iframeUrl) return iframeUrl;
    const entries = Object.entries(params || {}).filter(([, value]) => value !== undefined && value !== null && value !== "");
    if (!entries.length)
        return iframeUrl;
    const search = new URLSearchParams();
    entries.forEach(([key, value]) => search.set(key, String(value)));
    return `${iframeUrl}${iframeUrl.includes("?") ? "&" : "?"}${search.toString()}`;
}
